import * as React from 'react';

import { Formik, FormikProps } from 'formik';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { SimpleDialog } from './OrgsEmployees';
import { Member } from 'common/api/models/Member';
import { EligibleItem, EligibleItemMapping } from 'common/api/models/EligibleItem';
import { Order } from 'common/api/models/Order';
import * as moment from 'moment';

interface AddItemDialogProps extends SimpleDialog {
  user?: Member;
  items: EligibleItem[];
}

export const AddItemDialog = (props: AddItemDialogProps) => {
  const { items, user, onCancel, onConfirm } = props;

  const eligibleOrderProducts = user && user.vouchers ? user.vouchers : [];

  const alreadyAddedOrders = new Set(eligibleOrderProducts.map((item: EligibleItemMapping) => item.orderId));

  // Filter out all orders that have already been added
  const shownItems = items.filter(item => {
    return item.orders.every((order: Order) => !alreadyAddedOrders.has(order.id || ''));
  });

  const initialValues = shownItems.reduce((prev, cur) => {
    prev[cur.productId] = '';
    return prev;
  }, {});

  // Change handler to update formik state properly
  const handleFormChange = (
    productId: string,
    setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void
  ) => (event: React.ChangeEvent<any>) => {
    if (event.target.checked) {
      const id = event.target.name;
      setFieldValue(productId, id);
    } else {
      setFieldValue(productId, '');
    }
  };

  return (
    <Modal size="sm" isOpen={!!user} toggle={onCancel} keyboard={true}>
      <ModalHeader toggle={onCancel}>Add Item: {user ? user.name : ''}</ModalHeader>
      <Formik initialValues={initialValues} onSubmit={onConfirm}>
        {(form: FormikProps<any>) => (
          <form onSubmit={form.handleSubmit}>
            <ModalBody>
              {shownItems.map((item: EligibleItem) => (
                <div key={item.productId}>
                  <div>{item.productName}</div>
                  {item.orders.map(order => (
                    <label key={order.id}>
                      <input
                        type="checkbox"
                        id={order.id}
                        name={order.id}
                        checked={form.values[item.productId] === order.id}
                        onChange={handleFormChange(item.productId, form.setFieldValue)}
                      />{' '}
                      {`Order #${order.number} ${moment(order.createAt).format('MM/DD/YYYY')}`}
                    </label>
                  ))}
                </div>
              ))}
            </ModalBody>
            <ModalFooter>
              <div>
                <Button color="secondary" onClick={props.onCancel}>
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Save
                </Button>
              </div>
            </ModalFooter>
          </form>
        )}
      </Formik>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Orgs/AddItemDialog.tsx